import { initWorkItemsRoot } from '../../../work_items/index.js?vue3';

initWorkItemsRoot();
